/**
 * What is placed on a picture, for the badges in the product sheet.
 *
 * The same rules as the positioner and the proofsheet: for picture n of an
 * option, the option's own placement if it has one, else the one shared by
 * every option, else what the supplier placed on that very picture; for a
 * product picture, the reseller's placement by URL, else the supplier's.
 */
define('pimPicturePlaced',['underscore'], function (_) {
  'use strict';

  function count(positions) {
    return positions ? positions.length : 0;
  }

  return {
    /**
     * @param saved      the reseller's entries (pimPicturePositions), or []
     * @param optionPimId  the option, or null for a product picture
     * @param view       1-based picture number of the option, or null
     * @param url        the picture
     * @param supplierPositions  what the supplier placed on this picture
     * @return {count, own: true when the reseller placed it} or null when nothing is placed
     */
    onPicture: function (saved, optionPimId, view, url, supplierPositions) {
      saved = saved || [];
      if (view) {
        var override = _.find(saved, function (e) {
          return e.view === view && e.optionPimId === optionPimId;
        });
        if (override) {
          return count(override.positions) ? {count: count(override.positions), own: true} : null;
        }
        var shared = _.find(saved, function (e) {
          return e.view === view && !e.optionPimId;
        });
        if (shared) {
          return count(shared.positions) ? {count: count(shared.positions), own: true} : null;
        }
      } else {
        var product = _.find(saved, function (e) {
          return (e.view === null || e.view === undefined) && e.imageUrl === url;
        });
        if (product) {
          return count(product.positions) ? {count: count(product.positions), own: true} : null;
        }
      }
      return count(supplierPositions) ? {count: count(supplierPositions), own: false} : null;
    },

    /** The badge's tooltip. */
    title: function (placed) {
      var what = placed.count === 1 ?
        _.i18n('pimPositioner.placedOne', null, '1 print area placed') :
        _.i18n('pimPositioner.placedMany', null, '{n} print areas placed').replace('{n}', placed.count);
      return what + ' — ' + (placed.own ?
        _.i18n('pimPositioner.placedByYou', null, 'by you') :
        _.i18n('pimPositioner.placedBySupplier', null, 'by the supplier'));
    }
  };
});

